/**
 * @generated SignedSource<<160a9c4c72e3a7d798e22b5120662a6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetEmployeeLeaveInput = {
  setTeamIds?: ReadonlyArray<string> | null;
  setWhitelistLeaveReasonIds?: ReadonlyArray<string> | null;
};
export type WSEmployeeLeaveMutation$variables = {
  input: UpdateWidgetEmployeeLeaveInput;
  storecastId: string;
  widgetId: string;
};
export type WSEmployeeLeaveMutation$data = {
  readonly dashboard: {
    readonly updateWidgetEmployeeLeave: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly whitelistLeaveReasons: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type WSEmployeeLeaveMutation = {
  response: WSEmployeeLeaveMutation$data;
  variables: WSEmployeeLeaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          },
          {
            "kind": "Variable",
            "name": "widgetId",
            "variableName": "widgetId"
          }
        ],
        "concreteType": "WidgetEmployeeLeave",
        "kind": "LinkedField",
        "name": "updateWidgetEmployeeLeave",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LeaveReason",
            "kind": "LinkedField",
            "name": "whitelistLeaveReasons",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSEmployeeLeaveMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSEmployeeLeaveMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "4592c77a8dc99ac2e19dadc7df570b02",
    "id": null,
    "metadata": {},
    "name": "WSEmployeeLeaveMutation",
    "operationKind": "mutation",
    "text": "mutation WSEmployeeLeaveMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $input: UpdateWidgetEmployeeLeaveInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetEmployeeLeave(input: $input, widgetId: $widgetId) {\n      id\n      teams {\n        id\n      }\n      whitelistLeaveReasons {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f1d3a0b326b203ed5dbe028f9a8a98d";

export default node;
